import React, { useEffect, useState } from "react";

import { IoIosCheckmarkCircle } from "react-icons/io";
import shadeRight from "../../assets/pics/shadeRight.svg";
import shadeLeft from "../../assets/pics/shadeLeft.svg";
import SelectAndSearchHero from "../../components/shared/SelectAndSearchHero";
import HotelVenuModal from "../../components/HotelVenuModal1";
import { Link } from "react-router-dom";
import { FiMapPin, FiUsers } from "react-icons/fi";
import { HiOutlineSpeakerphone } from "react-icons/hi";
import { orderBy } from "lodash";
import { getURLParams } from "../../utils/utilityFunctions";

export const eventTypes1 = [
	{
		label: "Annual General meeting",
		value: "Annual General meeting",
		eventKey: "Conference/Seminars",
	},
	{ label: "Auctions", value: "Auctions", eventKey: "Conference/Seminars" },
	{
		label: "Board Meetings",
		value: "Board Meetings",
		eventKey: "Conference/Seminars",
	},
	{ label: "Breakout", value: "Breakout", eventKey: "Conference/Seminars" },
	{ label: "Conference", value: "Conference", eventKey: "Conference/Seminars" },
	{
		label: "Conventions",
		value: "Conventions",
		eventKey: "Conference/Seminars",
	},
	{
		label: "Executive Summits",
		value: "Executive Summits",
		eventKey: "Conference/Seminars",
	},
	{
		label: "Exhibitions",
		value: "Exhibitions",
		eventKey: "Conference/Seminars",
	},
	{ label: "Meetings", value: "Meetings", eventKey: "Conference/Seminars" },
	{ label: "Networking", value: "Networking", eventKey: "Conference/Seminars" },
	{
		label: "Presentation",
		value: "Presentation",
		eventKey: "Conference/Seminars",
	},
	{
		label: "Press Conference",
		value: "Press Conference",
		eventKey: "Conference/Seminars",
	},
	{
		label: "Product Launch",
		value: "Product Launch",
		eventKey: "Conference/Seminars",
	},
	{ label: "Seminars", value: "Seminars", eventKey: "Conference/Seminars" },
	{ label: "Symposium", value: "Symposium", eventKey: "Conference/Seminars" },
	{
		label: "Trade Shows",
		value: "Trade Shows",
		eventKey: "Conference/Seminars",
	},
	{ label: "Workshops", value: "Workshops", eventKey: "Conference/Seminars" },
	{
		label: "Activity Day",
		value: "Activity Day",
		eventKey: "Corporate Events",
	},
	{
		label: "Award Ceremony",
		value: "Award Ceremony",
		eventKey: "Corporate Events",
	},
	{ label: "Away day", value: "Away day", eventKey: "Corporate Events" },
	{ label: "Brainstorm", value: "Brainstorm", eventKey: "Corporate Events" },
	{
		label: "Charity event",
		value: "Charity event",
		eventKey: "Corporate Events",
	},
	{
		label: "Corporate Gala dinner",
		value: "Corporate Gala dinner",
		eventKey: "Corporate Events",
	},
	{
		label: "Corporate Reception",
		value: "Corporate Reception",
		eventKey: "Corporate Events",
	},
	{
		label: "Corporate Retreat",
		value: "Corporate Retreat",
		eventKey: "Corporate Events",
	},
	{ label: "FAM Trip", value: "FAM Trip", eventKey: "Corporate Events" },
	{ label: "Fundraiser", value: "Fundraiser", eventKey: "Corporate Events" },
	{
		label: "Incentive trip",
		value: "Incentive trip",
		eventKey: "Corporate Events",
	},
	{
		label: "Office Party",
		value: "Office Party",
		eventKey: "Corporate Events",
	},
	{
		label: "Outdoor Activity",
		value: "Outdoor Activity",
		eventKey: "Corporate Events",
	},
	{ label: "PR events", value: "PR events", eventKey: "Corporate Events" },
	{
		label: "Promotional Events",
		value: "Promotional Events",
		eventKey: "Corporate Events",
	},
	{ label: "Staff Party", value: "Staff Party", eventKey: "Corporate Events" },
	{
		label: "Summer Party",
		value: "Summer Party",
		eventKey: "Corporate Events",
	},
	{
		label: "Team Building",
		value: "Team Building",
		eventKey: "Corporate Events",
	},
	{
		label: "Training Program",
		value: "Training Program",
		eventKey: "Corporate Events",
	},
	{ label: "Arabic Wedding", value: "Arabic Wedding", eventKey: "Weddings" },
	{ label: "Beach Wedding", value: "Beach Wedding", eventKey: "Weddings" },
	{
		label: "Christian Wedding",
		value: "Christian Wedding",
		eventKey: "Weddings",
	},
	{ label: "Church Wedding", value: "Church Wedding", eventKey: "Weddings" },
	{
		label: "Civil Partnership",
		value: "Civil Partnership",
		eventKey: "Weddings",
	},
	{ label: "Civil Wedding", value: "Civil Wedding", eventKey: "Weddings" },
	{ label: "Garden Wedding", value: "Garden Wedding", eventKey: "Weddings" },
	{ label: "Hindu Wedding", value: "Hindu Wedding", eventKey: "Weddings" },
	{ label: "Indian Wedding", value: "Indian Wedding", eventKey: "Weddings" },
	{ label: "Marquee Wedding", value: "Marquee Wedding", eventKey: "Weddings" },
	{ label: "Outdoor Wedding", value: "Outdoor Wedding", eventKey: "Weddings" },
	{ label: "Unique Wedding", value: "Unique Wedding", eventKey: "Weddings" },
	{
		label: "Wedding Ceremony",
		value: "Wedding Ceremony",
		eventKey: "Weddings",
	},
	{
		label: "Wedding Reception",
		value: "Wedding Reception",
		eventKey: "Weddings",
	},
	{
		label: "Wedding",
		value: "Wedding",
		eventKey: "Weddings",
	},
	{ label: "BBQ", value: "BBQ", eventKey: "Social Gathering" },
	{
		label: "Anniversary Party",
		value: "Anniversary Party",
		eventKey: "Social Gathering",
	},
	{
		label: "Cocktail Masterclass",
		value: "Cocktail Masterclass",
		eventKey: "Social Gathering",
	},
	{
		label: "Cocktail Reception",
		value: "Cocktail Reception",
		eventKey: "Social Gathering",
	},
	{ label: "Communion", value: "Communion", eventKey: "Social Gathering" },
	{ label: "Condolences", value: "Condolences", eventKey: "Social Gathering" },
	{
		label: "Drinks Reception",
		value: "Drinks Reception",
		eventKey: "Social Gathering",
	},
	{
		label: "Engagement",
		value: "Engagement",
		eventKey: "Social Gathering",
	},
	{
		label: "Farewell Party",
		value: "Farewell Party",
		eventKey: "Social Gathering",
	},
	{
		label: "Funeral reception",
		value: "Funeral reception",
		eventKey: "Social Gathering",
	},
	{
		label: "Graduation Party",
		value: "Graduation Party",
		eventKey: "Social Gathering",
	},
	{
		label: "New Year's Eve Party",
		value: "New Year's Eve Party",
		eventKey: "Social Gathering",
	},
	{ label: "Party", value: "Party", eventKey: "Social Gathering" },
	{
		label: "Private Party",
		value: "Private Party",
		eventKey: "Social Gathering",
	},
	{
		label: "Retirement Party",
		value: "Retirement Party",
		eventKey: "Social Gathering",
	},
	{ label: "Reunions", value: "Reunions", eventKey: "Social Gathering" },
	{ label: "Stag Party", value: "Stag Party", eventKey: "Social Gathering" },
	{
		label: "Wine Tasting",
		value: "Wine Tasting",
		eventKey: "Social Gathering",
	},
	{
		label: "16th Birthday Party",
		value: "16th Birthday Party",
		eventKey: "Milestone Birthdays",
	},
	{
		label: "18th Birthday Party",
		value: "18th Birthday Party",
		eventKey: "Milestone Birthdays",
	},
	{
		label: "21st Birthday Party",
		value: "21st Birthday Party",
		eventKey: "Milestone Birthdays",
	},
	{
		label: "25th Birthday Party",
		value: "25th Birthday Party",
		eventKey: "Milestone Birthdays",
	},
	{
		label: "30th Birthday Party",
		value: "30th Birthday Party",
		eventKey: "Milestone Birthdays",
	},
	{
		label: "40th Birthday Party",
		value: "40th Birthday Party",
		eventKey: "Milestone Birthdays",
	},
	{
		label: "50th Birthday Party",
		value: "50th Birthday Party",
		eventKey: "Milestone Birthdays",
	},
	{
		label: "Birthday Party",
		value: "Birthday Party",
		eventKey: "Milestone Birthdays",
	},
	{
		label: "Afternoon Tea",
		value: "Afternoon Tea",
		eventKey: "Tea Party/Showers",
	},
	{
		label: "Baby Christening",
		value: "Baby Christening",
		eventKey: "Tea Party/Showers",
	},
	{ label: "Baby Shower", value: "Baby Shower", eventKey: "Tea Party/Showers" },
	{
		label: "Bachelorette/Bachelor Party",
		value: "Bachelorette/Bachelor Party",
		eventKey: "Tea Party/Showers",
	},
	{
		label: "Bridal Shower",
		value: "Bridal Shower",
		eventKey: "Tea Party/Showers",
	},
	{ label: "High Tea", value: "High Tea", eventKey: "Tea Party/Showers" },
	{
		label: "Children Birthday Party",
		value: "Children Birthday Party",
		eventKey: "Teen/Children",
	},
	{ label: "Kids Party", value: "Kids Party", eventKey: "Teen/Children" },
	{ label: "Teen Party", value: "Teen Party", eventKey: "Teen/Children" },
	{
		label: "Gender Reveals",
		value: "Gender Reveals",
		eventKey: "Special Big Events",
	},
	{ label: "Proposals", value: "Proposals", eventKey: "Special Big Events" },
	{ label: "Brunches", value: "Brunches", eventKey: "Cultural Cleberations" },
	{
		label: "Christmas dinner",
		value: "Christmas dinner",
		eventKey: "Cultural Celebrations",
	},
	{
		label: "Christmas Party",
		value: "Christmas Party",
		eventKey: "Cultural Celebrations",
	},
	{ label: "Diwali", value: "Diwali", eventKey: "Cultural Celebrations" },
	{ label: "Eid", value: "Eid", eventKey: "Cultural Celebrations" },
	{
		label: "Halloween Party",
		value: "Halloween Party",
		eventKey: "Cultural Celebrations",
	},
	{
		label: "Holiday Party",
		value: "Holiday Party",
		eventKey: "Cultural Celebrations",
	},
	{ label: "Iftar", value: "Iftar", eventKey: "Cultural Celebrations" },
	{
		label: "Ladies night",
		value: "Ladies night",
		eventKey: "Cultural Celebrations",
	},
	{ label: "Ramadan", value: "Ramadan", eventKey: "Cultural Celebrations" },
	{ label: "Suhoor", value: "Suhoor", eventKey: "Cultural Celebrations" },
	{
		label: "Xmas Party",
		value: "Xmas Party",
		eventKey: "Cultural Celebrations",
	},
	{
		label: "Filming/Video Recording",
		value: "Filming/Video Recording",
		eventKey: "Filming, Photography & Media",
	},
	{
		label: "Photoshoot",
		value: "Photoshoot",
		eventKey: "Filming, Photography & Media",
	},
	{
		label: "Podcast Recording",
		value: "Podcast Recording",
		eventKey: "Filming, Photography & Media",
	},
	{ label: "Book Launch", value: "Book Launch", eventKey: "Cultural" },
	{ label: "Film Festival", value: "Film Festival", eventKey: "Cultural" },
	{ label: "Music Festival", value: "Music Festival", eventKey: "Cultural" },
	{
		label: "Art Exhibitions",
		value: "Art Exhibitions",
		eventKey: "Art",
	},
	{
		label: "Concert",
		value: "Concert",
		eventKey: "Performances & Exhibitions",
	},
	{
		label: "Dance Performance",
		value: "Dance Performance",
		eventKey: "Performances & Exhibitions",
	},
	{
		label: "Fashion Show",
		value: "Fashion Show",
		eventKey: "Performances & Exhibitions",
	},
	{ label: "GIG", value: "GIG", eventKey: "Performances & Exhibitions" },
	{
		label: "Live Performance",
		value: "Live Performance",
		eventKey: "Performances & Exhibitions",
	},
	{
		label: "Performing Arts",
		value: "Performing Arts",
		eventKey: "Performances & Exhibitions",
	},
	{
		label: "Screening",
		value: "Screening",
		eventKey: "Performances & Exhibitions",
	},
	{
		label: "Stand-up Comedy",
		value: "Stand-up Comedy",
		eventKey: "Performances & Exhibitions",
	},
	{
		label: "Theatre (Drama/Plays)",
		value: "Theatre (Drama/Plays)",
		eventKey: "Performances & Exhibitions",
	},
	{ label: "Adventure venue", value: "Adventure venue", eventKey: "venues" },
	{ label: "Amphitheatre", value: "Amphitheatre", eventKey: "venues" },
	{ label: "Aquarium", value: "Aquarium", eventKey: "venues" },
	{ label: "Art Gallery", value: "Art Gallery", eventKey: "venues" },
	{ label: "Art studio", value: "Art studio", eventKey: "venues" },
	{ label: "Auditorium", value: "Auditorium", eventKey: "venues" },
	{ label: "Ballroom", value: "Ballroom", eventKey: "venues" },
	{ label: "Bar", value: "Bar", eventKey: "venues" },
	{ label: "Beach", value: "Beach", eventKey: "venues" },
	{ label: "Beach club", value: "Beach club", eventKey: "venues" },
	{ label: "Blank canvas", value: "Blank canvas", eventKey: "venues" },
	{ label: "Boats & Yachts", value: "Boats & Yachts", eventKey: "venues" },
	{ label: "Cafes", value: "Cafes", eventKey: "venues" },
	{ label: "Church", value: "Church", eventKey: "venues" },
	{ label: "Cinema", value: "Cinema", eventKey: "venues" },
	{ label: "Co-working space", value: "Co-working space", eventKey: "venues" },
	{ label: "Community center", value: "Community center", eventKey: "venues" },
	{ label: "Concert hall", value: "Concert hall", eventKey: "venues" },
	{
		label: "Conference center",
		value: "Conference center",
		eventKey: "venues",
	},
	{ label: "Courtyard", value: "Courtyard", eventKey: "venues" },
	{ label: "Dance Studio", value: "Dance Studio", eventKey: "venues" },
	{ label: "Desert", value: "Desert", eventKey: "venues" },
	{
		label: "Entertainment venue",
		value: "Entertainment venue",
		eventKey: "venues",
	},
	{ label: "Escape Rooms", value: "Escape Rooms", eventKey: "venues" },
	{ label: "EXPO", value: "EXPO", eventKey: "venues" },
	{ label: "Farm", value: "Farm", eventKey: "venues" },
	{
		label: "Fine dining restaurant",
		value: "Fine dining restaurant",
		eventKey: "venues",
	},
	{ label: "Garden", value: "Garden", eventKey: "venues" },
	{ label: "Golf courses", value: "Golf courses", eventKey: "venues" },
	{ label: "Helipad", value: "Helipad", eventKey: "venues" },
	{ label: "Karaoke bar", value: "Karaoke bar", eventKey: "venues" },
	{ label: "Kids play area", value: "Kids play area", eventKey: "venues" },
	{ label: "Lawn", value: "Lawn", eventKey: "venues" },
	{ label: "Limousine", value: "Limousine", eventKey: "venues" },
	{ label: "Meeting Center", value: "Meeting Center", eventKey: "venues" },
	{ label: "Meeting room", value: "Meeting room", eventKey: "venues" },
	{ label: "Museum", value: "Museum", eventKey: "venues" },
	{ label: "Nightclub", value: "Nightclub", eventKey: "venues" },
	{ label: "Park", value: "Park", eventKey: "venues" },
	{ label: "Party bus", value: "Party bus", eventKey: "venues" },
	{ label: "Patio", value: "Patio", eventKey: "venues" },
	{ label: "Photo studio", value: "Photo studio", eventKey: "venues" },
	{ label: "Poolside", value: "Poolside", eventKey: "venues" },
	{ label: "Recording studio", value: "Recording studio", eventKey: "venues" },
	{ label: "Restaurant", value: "Restaurant", eventKey: "venues" },
	{ label: "Restaurant/Bar", value: "Restaurant/Bar", eventKey: "venues" },
	{
		label: "Restaurant/Lounge & Bar",
		value: "Restaurant/Lounge & Bar",
		eventKey: "venues",
	},
	{ label: "Rooftops", value: "Rooftops", eventKey: "venues" },
	{
		label: "Rooftops Restaurant",
		value: "Rooftops Restaurant",
		eventKey: "venues",
	},
	{
		label: "Social clubs and lounges",
		value: "Social clubs and lounges",
		eventKey: "venues",
	},
	{ label: "Spa", value: "Spa", eventKey: "venues" },
	{ label: "Sports club", value: "Sports club", eventKey: "venues" },
	{ label: "Sports venue", value: "Sports venue", eventKey: "venues" },
	{ label: "Stadium", value: "Stadium", eventKey: "venues" },
	{ label: "Streaming studio", value: "Streaming studio", eventKey: "venues" },
	{ label: "Supper club", value: "Supper club", eventKey: "venues" },
	{ label: "Temple", value: "Temple", eventKey: "venues" },
	{ label: "Terrace", value: "Terrace", eventKey: "venues" },
	{ label: "Theme Park", value: "Theme Park", eventKey: "venues" },
	{ label: "Therapy room", value: "Therapy room", eventKey: "venues" },
	{ label: "Training room", value: "Training room", eventKey: "venues" },
	{ label: "TV film studio", value: "TV film studio", eventKey: "venues" },
	{ label: "Warehouse", value: "Warehouse", eventKey: "venues" },
	{ label: "Yoga Studio", value: "Yoga Studio", eventKey: "venues" },
	{ label: "Zoo", value: "Zoo", eventKey: "venues" },
];

const restaurantRelatedTypes = [
	"Bar",
	"Beach club",
	"Cafes",
	"Dinner Show",
	"Fine dining restaurant",
	"Karaoke bar",
	"Nightclub",
	"Restaurant",
	"Restaurant/Bar",
	"Restaurant/Lounge & Bar",
	"Rooftops Restaurant",
	"Social clubs and lounges",
	"Supper club",
];

const corporateVenue = [
	"Conference center",
	// "Ballroom",
	"Co-working space",
	"Exhibitions Halls",
	// "Golf courses",
	"Meeting Center",
	"Meeting room",
	// "Team activity",
	"Training room",
];

export const eventTypes = [
	...orderBy(
		eventTypes1.filter((event) => event.eventKey === "venues"),
		["label"],
		["asc"]
	),
	...orderBy(
		eventTypes1.filter((event) => event.eventKey !== "venues"),
		[
			(item) => {
				const startsWithNumeric = /^[0-9]/.test(item.label);
				return [startsWithNumeric ? 1 : 0, item.label.toLowerCase()];
			},
		],
		["asc"]
	),
];

const sortedEventTypes = eventTypes;
const HERO_NAMES = [
	"Ballroom",
	"Auditorium",
	"Restaurant",
	"Beach",
	"Kids Play Area",
	"Yacht",
	"Museum",
];

const HERO_IMAGES = [
	{
		name: "Ballroom",
		img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmv%20hero%2FBallroom_nh8xsg.jpg?alt=media&token=78868781-842b-48a2-b3e0-94bd6aab6310",
	},
	{
		name: "Auditorium",
		img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmv%20hero%2FAuditorium_nlijfq.png?alt=media&token=b3a36806-639a-4efa-b993-8a316cc72c4a",
	},
	{
		name: "Restaurant",
		img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmv%20hero%2FRestaurant-compressed_1_ey1kzn.jpg?alt=media&token=93f76a13-f1eb-4690-96de-8742462c79bf",
	},
	{
		name: "Beach",
		img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmv%20hero%2FBeach_xoyczu.jpg?alt=media&token=829cd9ab-697f-42bd-85d4-880d73d70ff4",
	},
	{
		name: "Kids Play Area",
		img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmv%20hero%2FKids_Play_Area_u0ivl3.jpg?alt=media&token=34e72fcd-b9ce-4bfa-bc43-6baf8e215e60",
	},
	{
		name: "Yacht",
		img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmv%20hero%2FYacht_m4grx3.jpg?alt=media&token=b87f9d55-391b-4354-84fc-bd48ac8141fd",
	},
	{
		name: "Museum",
		img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmv%20hero%2FMuseum_cvrxee.jpg?alt=media&token=ef794e1b-f0c5-4f98-aecd-3f379359ed85",
	},
];

const Hero = ({ filters, setFilters }) => {
	const [showHotelVenue, setShowHotelVenue] = useState(false);
	const [selectedCity, setSelectedCity] = useState("");
	const [selectedEvent, setSelectedEvent] = useState({});
	const [numberOfGuests, setNumberOfGuests] = useState("");
	const [heroIdx, setHeroIdx] = useState(0);

	console.log("SELEcTED DEVENT", selectedEvent);

	useEffect(() => {
		const timer = setInterval(() => setHeroIdx(i => (i + 1) % HERO_IMAGES.length), 2500);
		return () => clearInterval(timer);
	}, []);

	// Preload next image so the transition is instant
	useEffect(() => {
		const next = (heroIdx + 1) % HERO_IMAGES.length;
		const img = new window.Image();
		img.src = HERO_IMAGES[next].img;
	}, [heroIdx]);

	const names = HERO_NAMES;
	const images = HERO_IMAGES;
	const cities1 = [
		{ label: "Dubai", value: "Dubai" },
		{ label: "Abu Dhabi", value: "Abu Dhabi" },
		{ label: "Ras Al Khaimah", value: "Ras Al Khaimah" },
		{ label: "Sharjah", value: "Sharjah" },
		{ label: "Fujairah", value: "Fujairah" },
		{ label: "Ajman", value: "Ajman" },
		{ label: "Umm Al Quwain", value: "Umm Al Quwain" },
	];
	useEffect(() => {
		console.log(selectedCity);
		if (!selectedEvent) {
			setFilters({
				city: selectedCity,
				standingGuests: numberOfGuests,
			});
			return;
		}

		if (selectedEvent.eventKey === "venues") {
			setFilters({
				city: selectedCity,
				standingGuests: numberOfGuests,
				venueTypes: selectedEvent.label ? [selectedEvent.label] : [],
			});
		} else {
			const typeKeys = [
				"Conference/Seminars",
				"Corporate Events",
				"Weddings",
				"Dining",
				"Performances & Exhibitions",
				"Teen/Children",
				"Milestone Birthdays",
				"Tea Party/Showers",
				"Special Big Events",
				"Cultural Celebrations",
				"Filming, Photography & Media",
				"Cultural",
				"Art Spaces",
			];
			if (typeKeys.includes(selectedEvent.eventKey)) {
				setFilters({
					city: selectedCity,
					standingGuests: numberOfGuests,
					eventTypes: {
						[selectedEvent.eventKey]: selectedEvent.label
							? [selectedEvent.label]
							: [],
					},
				});
			} else {
				setFilters({
					city: selectedCity,
					standingGuests: numberOfGuests,
				});
			}
		}
	}, [selectedCity, numberOfGuests, selectedEvent]);

	return (
		<div className="relative mx-auto min-h-[750px] lg:h-auto">
			<div className="flex justify-center w-full sm:pt-20 pt-12 mx-auto ">
				<div className="w-[90%]  flex items-center  gap-10 justify-between mt-5">
					<div className="lg:w-[60%] w-full flex flex-col sm:items-start items-center sm:gap-6 gap-4">
						<h1 className="font-['Outfit'] font-semibold text-[32px] leading-[126%] tracking-[0%] text-center sm:text-start md:text-[54px] xl:text-[76px]">
							Search & Compare
							<span className="text-[#FF3939] block"> Venues Across UAE.</span>
						</h1>
						<p className="sm:text-[20px] text-[14px] sm:text-start text-center lg:font-[400]">
							The UAE's #1 venue search platform for discovering venues for
							meetings, corporates, parties, wedding & beyond.
						</p>

						<div className="bg-white py-5 px-5 z-20 flex flex-col md:flex-row items-center md:items-center w-full rounded-lg shadow-lg">
							{/* Container for Search Inputs */}
							<div className="flex flex-col md:flex-row w-full xl:w-[90%] gap-2 md:gap-4">
								<div className="relative flex items-center w-full border border-gray-300 rounded-lg px-4 shadow-sm h-[50px] bg-white">
									<HiOutlineSpeakerphone className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-lg" />
									<div className="w-full flex items-center h-full">
										<SelectAndSearchHero
											options={sortedEventTypes}
											onSelect={(value) => {
												setSelectedEvent(value);
												if (restaurantRelatedTypes.includes(value.label)) {
													setFilters((prevFilters) => ({
														...prevFilters,
														venueTypes: [...restaurantRelatedTypes],
													}));
												} else if (corporateVenue.includes(value.label)) {
													setFilters((prevFilters) => ({
														...prevFilters,
														venueTypes: [...corporateVenue],
													}));
												}
											}}
											selectedOption={selectedEvent?.label}
											placeholder="Event/Venue Type"
											className="w-full h-[50px] pl-2 flex  items-center justify-center placeholder-[#B0B0B0] text-[16px] font-[400] bg-transparent outline-none mb-1"
										/>
									</div>
								</div>

								{/* Guests Input */}
								<div className="relative flex items-center w-full border border-gray-300 rounded-lg px-4 shadow-sm h-[50px] bg-white">
									<FiUsers className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-lg" />
									<input
										type="number"
										min={1}
										className="w-full h-[50px] flex items-center justify-center pl-8 text-[16px] font-[400] text-black placeholder-[#B0B0B0] bg-transparent outline-none"
										placeholder="Guests"
										value={numberOfGuests ? numberOfGuests : ""}
										onChange={(e) => {
											const value = e.target.value;
											if (
												value === "" ||
												(!isNaN(value) && Number(value) > 0)
											) {
												setNumberOfGuests(value);
											}
										}}
									/>
								</div>

								{/* Location */}
								<div className="relative flex items-center w-full border border-gray-300 rounded-lg px-4 shadow-sm h-[50px] bg-white">
									<FiMapPin className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-lg" />
									<div className="w-full flex items-center h-full">
										<SelectAndSearchHero
											options={cities1}
											onSelect={(value) =>
												setSelectedCity(value ? value.label : "")
											}
											selectedOption={selectedCity}
											placeholder="Location"
											className="w-full  h-[50px] pl-3 flex items-center justify-center placeholder-[#B0B0B0] text-[16px] font-[400] bg-transparent outline-none mb-1"
										/>
									</div>
								</div>
							</div>

							<Link
								to={{
									pathname: "/listing/1",
									// search: `?${getURLParams(filters)}`,
								}}
								state={{
									city: selectedCity,
									event: selectedEvent,
									guests: numberOfGuests,
									filters: filters,
								}}
								className="flex h-full  md:w-[12%] w-full justify-center items-center"
							>
								<button className="bg-[#FE4747] md:w-auto w-full rounded-lg text-white py-2 px-4 lg:text-[16px] lg:font-[500]">
									Search
								</button>
							</Link>
						</div>
						<button
							onClick={() => setShowHotelVenue(true)}
							className="z-10 bg-[#FF3939] text-white px-6 py-2 rounded-full shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300"
						>
							Are you looking for Hotel Room + Venue?
						</button>

					</div>

					<div className="w-[30%] lg:flex hidden  justify-center">
						{/* <img src={img} alt='' /> */}
						<div className="relative w-full h-auto min-h-[400px] mb-0 justify-center gap-5 flex flex-col items-center">
							{/* ClipPath SVG Definition */}
							<div className="w-[354px] h-full flex -mt-8 mr-7 justify-center items-center relative">
								<svg
									className="absolute left-1/2 -translate-x-1/2 top-0 h-0 w-0"
									xmlns="http://www.w3.org/2000/svg"
								>
									<defs>
										<clipPath
											id="clip0_3556_4522"
											clipPathUnits="userSpaceOnUse"
										>
											<path d="M195.953 196C206.733 196 215.962 192.162 223.638 184.485C231.315 176.808 235.153 167.58 235.153 156.8C235.153 146.02 231.315 136.792 223.638 129.115C215.962 121.438 206.733 117.6 195.953 117.6C185.173 117.6 175.945 121.438 168.268 129.115C160.592 136.792 156.753 146.02 156.753 156.8C156.753 167.58 160.592 176.808 168.268 184.485C175.945 192.162 185.173 196 195.953 196ZM195.953 392C143.36 347.247 104.078 305.678 78.1083 267.295C52.1383 228.912 39.1533 193.387 39.1533 160.72C39.1533 111.72 54.915 72.6833 86.4383 43.61C117.962 14.5367 154.467 0 195.953 0C237.44 0 273.945 14.5367 305.468 43.61C336.992 72.6833 352.753 111.72 352.753 160.72C352.753 193.387 339.768 228.912 313.798 267.295C287.828 305.678 248.547 347.247 195.953 392Z" />
										</clipPath>
									</defs>
								</svg>

								{/* Only current image is in DOM — no wasted fetches */}
								<div className="image-container w-full h-full flex justify-center relative">
									<img
										key={heroIdx}
										src={images[heroIdx].img}
										alt={images[heroIdx].name}
										fetchPriority={heroIdx === 0 ? "high" : undefined}
										decoding="async"
										className="hero-slide w-full h-full object-cover absolute left-0 top-0"
										style={{
											clipPath: "url(#clip0_3556_4522)",
											WebkitClipPath: "url(#clip0_3556_4522)",
										}}
									/>
								</div>
							</div>

							{/* Text container — only current name rendered */}
							<div className="text-container w-full h-auto relative flex justify-center items-center">
								<div
									key={heroIdx}
									className="hero-text lg:text-[40px] sm:text-3xl text-2xl text-[#FE4747] font-semibold tracking-wide absolute"
								>
									{names[heroIdx]}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="bg-[#FFF5F5] flex justify-center py-8 px-2 w-full mb-3 mt-[100px]">
				<div className="sm:flex hidden items-center gap-2">
					<IoIosCheckmarkCircle className="text-[#FE4747] text-3xl" />
					<h1 className="text-[#222222] font-medium text-[32px]">
						No Booking fees, No commission - Just Connections.
					</h1>
				</div>
				<div className="sm:hidden flex items-center gap-4 px-2">
					<div className="flex items-center gap-2">
						<IoIosCheckmarkCircle className="text-[#FE4747] w-6 h-6" />
						<h1 className="text-[#222222] text-xs font-semibold whitespace-nowrap">
							No Booking Fee
						</h1>
					</div>
					<div className="w-[2px] h-full bg-[#FE4747]"></div>
					<div className="flex items-center gap-2">
						<IoIosCheckmarkCircle className="text-[#FE4747] w-9 h-9" />
						<h1 className="text-[#222222] text-xs font-semibold">
							No Commission Fee - Just Connections
						</h1>
					</div>
				</div>
			</div>
			<img src={shadeRight} className="absolute top-[0%] right-0 z-1" alt="" />
			<img src={shadeLeft} className="absolute top-[0%] left-0 z-1" alt="" />

			<HotelVenuModal
				onSubmit={() => {
					console.log("submit");
					setShowHotelVenue(false);
					window.location.href = "/listing/1";
				}}
				filters={filters}
				setFilters={setFilters}
				cities={cities1}
				eventTypes={sortedEventTypes}
				showHotelVenue={showHotelVenue}
				setShowHotelVenue={setShowHotelVenue}
			/>
		</div>
	);
};

export default Hero;
